export function RC4(key) {
    const S = Array(256)
      .fill()
      .map((_, i) => i);
    let j = 0;
    for (let i = 0; i < 256; i++) {
      j = (j + S[i] + key.charCodeAt(i % key.length)) % 256;
      [S[i], S[j]] = [S[j], S[i]];
    }
    return S;
  }
  
  export function encryptRC4(input, key) {
    const S = RC4(key);
    let i = 0,
      j = 0;
    return input
      .split("")
      .map((char) => {
        i = (i + 1) % 256;
        j = (j + S[i]) % 256;
        [S[i], S[j]] = [S[j], S[i]];
        return String.fromCharCode(char.charCodeAt(0) ^ S[(S[i] + S[j]) % 256]);
      })
      .join("");
  }
  
  export function decryptRC4(input, key) {
    return encryptRC4(input, key); // RC4 加密和解密使用相同的过程
  }